export const initLanguageMenu = () => {
  if ($("#languageMenuDesktop, #languageMenuMobile").length) {
    $("#languageMenuDesktop, #languageMenuMobile").smartmenus({
      subIndicators: false,
      showOnClick: true,
      hideOnClick: true,
      showDuration: 100,
      hideDuration: 100,
      subMenusMaxWidth: "100%",
      subMenusMinWidth: "100%"
    });
  }
};

export const initLanguageMenuLogin = () => {
  if ($("#languageMenuLogin").length) {
    $("#languageMenuLogin").smartmenus({
      bottomToTopSubMenus: true,
      collapsibleBehavior: "toggle",
      subIndicators: false,
      showOnClick: true,
      hideOnClick: true,
      showDuration: 100,
      hideDuration: 100,
      subMenusMaxWidth: "100%",
      subMenusMinWidth: "100%"
    });
  }
};
